import { render, staticRenderFns } from "./database2.vue?vue&type=template&id=4914a395&scoped=true&"
import script from "./database2.vue?vue&type=script&lang=js&"
export * from "./database2.vue?vue&type=script&lang=js&"
import style0 from "./database2.vue?vue&type=style&index=0&id=4914a395&prod&lang=css&"
import style1 from "./database2.vue?vue&type=style&index=1&id=4914a395&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4914a395",
  null
  
)

export default component.exports